<template>
  <div id="app" :class="{ menuOpen: toggleMainSidebar == true }">
    <TheSideNav />
    <el-container class="fullContainer">
      <div class="sidemenu-left-box">
        <el-aside class="sidemenu-left" width="299px">
          <MenuSide />
          <!--left side bar-->
        </el-aside>
      </div>
      <div class="mincontainer">
        <el-container>
          <el-header>
            <Header />
          </el-header>
          <el-main>
            <router-view />
          </el-main>
          <el-footer>
            <Footer />
          </el-footer>
        </el-container>
      </div>
    </el-container>
  </div>
</template>

<script>
import { mapActions } from "vuex"
import Header from "@/components/Header.vue"
import Footer from "@/components/Footer.vue"
import TheSideNav from "@/components/TheSideNav"
import MenuSide from "@/components/MenuSide.vue"
import { store } from "@/store/store.js"

export default {
  name: "app",
  components: {
    Header,
    MenuSide,
    TheSideNav,
    Footer,
  },
  created() {
    window.addEventListener("resize", this.windowResizeListener)
  },
  mounted() {
    this.windowResizeListener(this)
  },
  methods: {
    ...mapActions(["setSmallDevice"]),
    windowResizeListener(e) {
      let windowWidth = e.target ? e.target.innerWidth : e.$el.offsetWidth
      this.setSmallDevice(windowWidth < 1024)
    },
  },
  destroyed() {
    window.removeEventListener("resize", this.windowResizeListener)
  },
  computed: {
    toggleMainSidebar() {
      return store.state.toggleMainSidebar
    },
  },
}
</script>

<style>
html,
body {
  margin: 0;
  height: 100%;
  width: 100%;
  font-family: "Segoe UI", "Microsoft JhengHei", "Microsoft YaHei", "Arial";
  font-size: 14px;
}

body p,
body div,
body span,
body a,
body button {
  font-family: "Segoe UI", "Microsoft JhengHei", "Microsoft YaHei", "Arial";
}
body .el-menu {
  border-right: none;
  position: absolute;
}
body .el-tabs__item:hover {
  color: #fff;
}
body {
  background-color: #efefef;
}

body .el-input.is-disabled .el-input__inner {
  color: #606266;
}
.boxContain {
  margin: 10px 0;
}
.el-header {
  padding: 0;
  z-index: 100;
}
.el-aside {
  background-color: #fff;
  text-align: center;
  height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
}
.el-main {
  box-sizing: border-box;
  /* padding: 20px 0px 100px 0px; */
  width: 90%;
  margin: 0 auto;
}
.el-header {
  height: 50px !important;
}
.el-footer {
  height: 50px !important;
  padding: 0;
}
.mincontainer {
  box-sizing: border-box;
  width: 100%;
}
.mincontainer > .el-container > .el-main {
  padding-bottom: 20px;
}
.menuOpen .mincontainer {
  padding-left: 300px;
}

.fullContainer.sidemenu-close .sidemenu-left {
  transition: all 0.3s ease-out;
  transform: translateX(-300px);
}

/*.fullContainer.sidemenu-close .mincontainer{
	padding-left: 0px
}*/
.fullContainer.sidemenu-close .fixed-top {
  left: 0px;
}

.menuOpen .sidemenu-left-box {
  transform: translateX(0px);
}
.sidemenu-left-box {
  transition: all 0.1s ease-out;
  transform: translateX(-300px);
  position: fixed;
  top: 0;
  bottom: 0;
}
h3 {
  color: #009ae0;
  margin: 0.5rem 0;
}
li {
  margin: 0;
  padding: 0;
  list-style: none;
}
/*Bottons*/
.orange-button,
.orange-button:focus {
  /*background: #0a64a1;*/
  background: #e6a23c;
  color: #fff;
  border-color: #845b1f;
  outline: none;
  box-shadow: none;
  box-shadow: 0 2px #845b1f;
}
.orange-button:hover {
  background: #ca8b2e;
  color: #fff;
  border-color: #845b1f;
}
.orange-button:active {
  transform: translateY(1px);
  box-shadow: 0 1px #845b1f;
}
.button-right {
  float: right;
}

body .blue-button,
body .blue-button:focus {
  /*background: #0a64a1;*/
  background: #50c9ff;
  color: #fff;
  border-color: #009ae0;
  outline: none;
  box-shadow: none;
  box-shadow: 0 2px #0077ad;
}
body .blue-button:hover {
  background: #20b9ff;
  color: #fff;
  border-color: #009ae0;
}
body .blue-button:active {
  transform: translateY(1px);
  box-shadow: 0 1px #0077ad;
}
.buttons {
  overflow: hidden;
}
.el-select {
  width: 100%;
}
.el-autocomplete {
  width: 100%;
}
.c-form.boxContain {
  background-color: #fff;
  padding: 25px 25px 5px 25px;
  margin: 20px 0px;
  border-width: 0px 0px 0px 5px;
  border-style: solid;
  border-radius: 4px;
  border-color: #00a0e9;
}
.c-form .el-row {
  font-size: 16px;
  line-height: 50px;
  box-sizing: border-box;
}
.c-form .el-form-item {
  font-size: 14px;
}
body .el-date-editor--daterange.el-input__inner {
  width: 100%;
}
@media (max-width: 1025px) {
  .sidemenu-left {
    display: none;
  }
  .el-main {
    padding: 20px;
  }
  .menuOpen .mincontainer {
    padding-left: 0px;
    /*background: #000000;*/
  }
  .menu-side:not(.el-menu--collapse) {
    width: 240px;
    /*border-right: solid 0px #e6e6e6;*/
  }
  .menuSideTopBox {
    display: none;
  }
  #app .nav-item {
    border-top: 1px #ccc solid;
    border-bottom: 1px #ccc solid;
    margin: 50px 0 10px 0;
    padding: 10px 0 10px 10px;
  }
  #app .nav-item span {
    color: #000000;
  }
  #app .menu-side {
    top: 150px;
    background-color: none;
  }
  .menu-side-title {
    display: none;
  }
  #app .sidenav {
    background-color: #fff;
  }
  #app .menuitem {
    background-color: red;
  }
  .sidenav li > div > span {
    background-color: #0089c8;
  }
  .el-row .el-col-12 {
    width: 100%;
  }
  h3.includeBtn {
    margin-top: 30px;
  }
  .boxContain.includeBtn .c-table-top-right-btn {
    position: absolute;
    top: -50px;
    right: 0px;
  }
  @media (max-width: 768px) {
    .el-main {
      width: 100%;
    }
  }
}
</style>
